import { render, staticRenderFns } from "./ChatOrderProfileDetailForm.vue?vue&type=template&id=5275f3fa&"
import script from "./ChatOrderProfileDetailForm.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProfileDetailForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports